import React, { useCallback, useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import Button from '../Buttons/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {ButtonSize, ModalSize} from '../../Data/Enums/Generic';
import { ColourMod } from '../../Data/Enums/LayoutEnums';
import { useOutsiderDetector } from '../../Hooks/useOutsiderDetector';
import { faTimes } from '@fortawesome/pro-solid-svg-icons/faTimes';
import {modalPortalEl, useLayout} from "../../Providers/LayoutProvider";
import {GlobalHotKeys} from "react-hotkeys";
import {ModalType} from "./ModalTypes";

const Modal = (props: ModalType) => {
	const overlayRef = useRef(null);
	const { updateOverlayOpen } = useLayout();

	useOutsiderDetector(overlayRef, () => props.isOpen && !props.lockOpen ? HandleClose()  : null);

	const HandleClose = useCallback(() => {
		//updateOverlayOpen(false);
		if(props.closeCallback && !props.lockOpen) {
			props.closeCallback();

		}
	}, [props]);

	const keyMap = {
		CLOSE: "esc",
	};

	const KeyboardHandler = {
		CLOSE: HandleClose
	}

	const MapModalSize = (size: ModalSize) => {
		switch(size) {
			case ModalSize.Small:
				return 'col-center-md-4 col-center-lg-4 col-center-xl-2 col-center-uw-4';
			case ModalSize.Large:
				return 'col-center-md-8 col-center-lg-6 col-center-xl-5 col-center-uw-6';
			case ModalSize.ExtraLarge:
				return 'col-center-md-12 col-center-lg-8 col-center-xl-5 col-center-uw-6';
			default:
				return 'col-center-md-6 col-center-lg-4 col-center-xl-4 col-center-uw-4';
		}
	}

	let modalSizeClass = MapModalSize(props.modalSize as ModalSize);

/*	useEffect(() => {
		console.log('eff open?', props.isOpen);
		updateOverlayOpen(props.isOpen ?? false);
	}, [props.isOpen]);*/

	return (
		ReactDOM.createPortal(
			<div className={`overlay ${props.isOpen ? 'open' : '' } `} aria-labelledby="overlayTitle" role="dialog">
				<GlobalHotKeys keyMap={keyMap} handlers={KeyboardHandler} allowChanges={true}>
					<div className={'overlay-content'} ref={overlayRef}>
						{props.customContentWrapper && (
							<>
								{props.children}
								<Button title={'Close'} onClick={() => HandleClose()} />
							</>
						)}

						{!props.customContentWrapper && (
							<div className="row m-a">
								<div className={`col-center ${modalSizeClass} pl-sm pr-sm`}>

									<div className="overlay-header">
										{!props.lockOpen && (
											<>
												{!props.inlineTitle && (
													<h4 id="overlayTitle" className={'m-0'}>{props.title}</h4>
												)}

												<div className={'ml-a'}>
													<Button noKeyboardFocus={true} colour={ColourMod.Alert} size={ButtonSize.Small} title={'Close'} iconOnly={true} icon={ <FontAwesomeIcon icon={faTimes} /> } onClick={() => HandleClose()}/>
												</div>
											</>
										)}
									</div>

									<div className="overlay-body">
										{props.headerContent && (
											<div className={'card-header-content'}>
												{props.headerContent}
											</div>
										)}

										{props.inlineTitle && (
											<h4 className={'text-center mb-xs'}>{props.title}</h4>
										)}

										{props.children}
									</div>
								</div>
							</div>
						)}
					</div>
				</GlobalHotKeys>
			</div>,
			modalPortalEl
		)
	);
};

export default Modal
